import filesApi from '@/api/files/filesApi'
import { Document } from '@/classes/case/Document'

const state = {
  files: []
}

const mutations = {
  setStateFiles: (state, data) => {
    state.files = data
  }
}

const actions = {
  getFiles ({ commit }, caseId) {
    return filesApi.getFiles(caseId).then((response) => {
      let data = response.data.map((data) => {
        return {
          title: data.data_objects[0].label,
          files: data.data_objects[0].files
        }
      })
      let documents = Document.asDocuments(data)
      commit('setStateFiles', documents)
      return documents
    }).catch((err) => {
      throw err
    })
  },
  deleteFile ({ commit }, url) {
    return filesApi.deleteFile(url).then(() => {
      return true
    }).catch((err) => {
      throw err
    })
  }
}

export default {
  state,
  mutations,
  actions
}
